import CategoryHeader, { CategoryHeaderProps } from '@/components/elements/CategoryHeader';
import { classnames } from '@/helpers';

type GridLayoutSectionProps = {
  categoryHeader: CategoryHeaderProps;
  className?: string;
  gridContainerClassName?: string;
};

const GridLayoutSection = ({
  categoryHeader,
  children,
  className = '',
  gridContainerClassName = '',
}: GridLayoutSectionProps & { children: React.ReactNode }) => {
  const searchResultsContainerClassName = classnames(
    'gap-md grid grid-flow-row-dense grid-cols-[repeat(auto-fill,minmax(312px,1fr))]',
    gridContainerClassName,
  );

  return (
    <div className={className}>
      <CategoryHeader {...categoryHeader} />
      <div className={searchResultsContainerClassName}>{children}</div>
    </div>
  );
};

export default GridLayoutSection;
